export default class Geometry {
  constructor({ coordinates, type } = {}) {
    this.coordinates = coordinates || [0, 0];
    this.type = type || "";
  }
  getDataForCreateOrEditPost() {
    return {
      coordinates: this.coordinates,
      type: this.type
    };
  }
}
